module.exports = __webpack_public_path__ + "static/headerRightBg-e47bae764806e6cd1bea209de9d1619c.png";